import {
	Avatar,
	ButtonBase,
	Card,
	CardHeader,
	CardContent,
	Checkbox,
	Icon,
	ListItemText,
	makeStyles,
	MenuItem,
	TextField,
	Typography,
	useTheme,
	CardActions,
	Button
} from '@material-ui/core'

import Axios from 'axios'
import Autocomplete from '@material-ui/lab/Autocomplete'
import clsx from 'clsx'
import React, { useState, useEffect, useRef, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { withFirebaseHOC } from '../../Firebase/context'
import { api } from '../../../services/api'
import Confirmation from '../../Dialogs/Misc/Confirmation'
import { DeletableChip } from '../../Misc/DeletableChip'
import LoadingOverlayContained from '../../Misc/LoadingOverlayContained'
import { showSuccess, showError } from '../../../actions/misc/misc.actions'
import { uploadStaffProfilePhoto, updateStaff } from '../../../actions/Team/team.actions'
import { getFacilities } from '../../../actions/facilities/facilities.actions'
import { APP_OPTIONS, USER_ROLES } from '../../../utils'
import useCurrentUser from '../../../hooks/useCurrentUser'
// import { useHistory } from 'react-router-dom'

import MaskedInput from 'react-text-mask'

function TextMaskCustom(props) {
	const { inputRef, ...other } = props

	return (
		<MaskedInput
			{...other}
			ref={(ref) => {
				inputRef(ref ? ref.inputElement : null)
			}}
			mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
			placeholderChar={'\u2000'}
			showMask
		/>
	)
}
const appOptions = Object.keys(APP_OPTIONS)
const grooming_services = ['cleanup', 'trim', 'haircut', 'basic bath']
const speed_factors = [0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 1.6, 1.7, 1.8]
const staffSexOptions = ['Male', 'Female', 'Other']
const staffPositionOptions = [
	'Pet Care Associate',
	'Pet Care Supervisor',
	'Support Associate',
	'Support Supervisor',
	'Social Associate',
	'Social Supervisor',
	'Dog Trainer',
	'Bartender',
	'Bar Supervisor',
	'Groomer',
	'Groom Tech',
	'Management',
	'Other'
]
const staffTrainingOptions = [
	'Home Services',
	'Group Play',
	'Support',
	'Bar',
	'Social',
	'Consultation Training',
	'Dog Training'
]
const roleOptions = ['Back Office User', 'Support User', 'PCA Supervisor User', 'Groomer', 'Super User']

const useStyles = makeStyles((theme) => ({
	grid: {
		display: 'grid',
		gridGap: '23px',
		gridTemplateColumns: 'repeat(auto-fill, minmax(274px, 1fr))',
		marginBottom: '23px'
	},
	gridDouble: {
		display: 'grid',
		gridGap: '23px',
		gridTemplateColumns: 'repeat(auto-fill, minmax(424px, 1fr))',
		'& .field-wrapper': {
			'& .MuiTextField-root': {
				minWidth: '424px !important'
			}
		}
	},
	fileUpload: {
		gridColumn: 'auto / span 1',
		gridRow: 'auto / span 3',
		justifySelf: 'center'
	},
	fieldWrapper: {
		'& .MuiTextField-root': {
			minWidth: '274px !important'
		}
	},
	imageUploadButton: {
		height: 208,
		width: 208,
		background: 'transparent',
		borderRadius: '50%',
		border: '1px solid #D0CFD2',
		'&:hover': {
			borderColor: theme.palette.secondary.main
		}
	},
	fileUploadWrapper: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		flexDirection: 'column'
	},
	fileUploadIcon: {
		'&::before': {
			color: '#6B4AD6'
		}
	},
	input: {
		display: 'none'
	},
	petProfileImage: {
		width: '100%',
		height: '100%'
	},
	datePicker: {
		margin: 0
	},
	calendarHeaderButtons: {
		fill: theme.palette.primary.main
	},
	calendarButton: {
		'& svg': {
			fill: '#777679'
		}
	},
	autoComplete: {
		'& .MuiFilledInput-root': {
			paddingTop: '17px'
		},
		'& .Mui-focused': {
			'& .MuiAutocomplete-endAdornment svg': {
				fill: theme.palette.secondary.main
			}
		},
		'& .MuiAutocomplete-endAdornment svg': {
			fill: '#777679'
		}
	},
	deleteButton: {
		color: '#D32F2F',
		borderColor: '#D32F2F',
		'&:hover': {
			color: '#FFFFFF',
			backgroundColor: '#D32F2F'
		}
	},
	cardActions: {
		justifyContent: 'space-between'
	}
}))

const StaffInfoCard = (props) => {
	const classes = useStyles()
	const theme = useTheme()
	// const history = useHistory()
	const dispatch = useDispatch()
	const inputRef = useRef(null)
	// const firebase = props.firebase
	const imageRepo = `https://${process.env.REACT_APP_S3_BUCKET}.s3.amazonaws.com/`
	const loading = useSelector((state) => state.specific.team.loading)
	const { isSuperUser } = useCurrentUser()
	// const error = useSelector((state) => state.specific.team.error)

	let { staffMember, setCurrent, onPasswordResetClick } = props

	const handlePasswordResetClick = useCallback(() => {
		if (onPasswordResetClick) {
			onPasswordResetClick()
		}
	}, [onPasswordResetClick])

	const [isDeactivationDialogShown, setIsDeactivationDialogShown] = useState(false)
	const [isActivationDialogShown, setIsActivationDialogShown] = useState(false)

	const facilitiesLoading = useSelector((state) => state.specific.facilities.loading)
	const facilities = useSelector((state) => state.specific.facilities.facilities)

	useEffect(() => {
		if (!facilities && !facilitiesLoading) {
			dispatch(getFacilities())
		}
	}, [dispatch, facilities, facilitiesLoading])

	const renderImageUpload = () => (
		<div className={classes.fileUploadWrapper}>
			<Icon className={clsx(['fas fa-image', classes.fileUploadIcon])} />
			<Typography variant="body2" style={{ color: theme.palette.secondary.main }}>
				Upload Picture *
			</Typography>
		</div>
	)

	const updateStaffState = (field, value) => {
		setCurrent({ ...staffMember, [field]: value })
	}

	const removeService = (service) => {
		let updatedServices = [...staffMember.permitted_grooming_services]
		let serviceIndex = updatedServices.findIndex((t) => t === service)

		if (serviceIndex !== -1) {
			updatedServices.splice(serviceIndex, 1)
		}

		updateStaffState('permitted_grooming_services', updatedServices)
	}

	useEffect(() => {
		if (staffMember?.position !== 'Groomer' && staffMember?.permitted_grooming_services?.includes('haircut'))
			removeService('haircut')
	}, [staffMember])

	const removeTraining = (training) => {
		let updatedTrainings = [...staffMember.trainings_completed]
		let trainingIndex = updatedTrainings.findIndex((t) => t === training)

		if (trainingIndex !== -1) {
			updatedTrainings.splice(trainingIndex, 1)
		}

		updateStaffState('trainings_completed', updatedTrainings)
	}

	const removePermission = (p) => {
		let updatedRoles = [...staffMember.roles]
		let trainingIndex = updatedRoles.findIndex((t) => t === p)

		if (trainingIndex !== -1) {
			updatedRoles.splice(trainingIndex, 1)
		}

		updateStaffState('roles', updatedRoles)
	}

	const removeApp = (app) => {
		let updatedApps = [...staffMember.apps]
		let appIndex = updatedApps.findIndex((t) => t === app)

		if (appIndex !== -1) {
			updatedApps.splice(appIndex, 1)
		}

		updateStaffState('apps', updatedApps)
	}

	const uploadPhoto = (e) => {
		let file

		if (e.target.files && e.target.files.length && e.target.files[0]) {
			file = e.target.files[0]

			const data = new FormData()
			data.append('profile_image', file)
			if (!staffMember._id) {
				saveImage(file)
			} else {
				dispatch(uploadStaffProfilePhoto(staffMember._id, data)).then(() => {
					inputRef.current.value = null
				})
			}
		}
	}

	const saveImage = async (file) => {
		try {
			let urlData = await api.get(`/getSignedUrl`)
			let url = urlData.data.url
			let newUrl = `https://${process.env.REACT_APP_S3_BUCKET}.s3.amazonaws.com/${urlData.data.key}`

			let response = await Axios({
				url: url,
				method: 'put',
				headers: {},
				transformRequest: [
					(data, headers) => {
						if (headers) {
							if (headers.common && headers.common.Authorization) delete headers.common.Authorization
							if (headers.common) {
								headers.common['Content-Type'] = 'image/jpeg'
							} else {
								headers.common = { 'Content-Type': 'image/jpeg' }
							}
							if (headers.put) {
								headers.put['Content-Type'] = 'image/jpeg'
							} else {
								headers.put = { 'Content-Type': 'image/jpeg' }
							}
							return data
						} else {
							return data
						}
					}
				],
				data: file
			})
			setCurrent({ ...staffMember, image_url: urlData.data.key })
			dispatch(showSuccess('Profile image uploaded successfully.'))
		} catch (error) {
			dispatch(showError('An error occured while uploading this profile image.'))
		}
	}

	const updateStaffActiveStatus = (activeStatus) => {
		let updates = {
			...staffMember,
			active: activeStatus
		}

		updateStaffState(staffMember._id, updates)
		dispatch(updateStaff(staffMember._id, updates))

		if (activeStatus) setIsActivationDialogShown(false)
		else setIsDeactivationDialogShown(false)
	}

	const onlyNumbers = (value) => {
		if (!value || value === '0') return value
		const onlyNums = value.toString().replace(/[^\d]/g, '').replace(/^0+/, '')
		if (onlyNums.length) return onlyNums
		return 0
	}

	const visibleRoleOptions = isSuperUser
		? roleOptions
		: roleOptions.filter((role) => role !== USER_ROLES.SuperUser)

	const canEditRole = (role) => staffMember.active && (isSuperUser || role !== USER_ROLES.SuperUser)

	const hasAdminAccess =
		!!staffMember?.uid_map?.find((i) => i.app === 'admin') ||
		!!staffMember?.apps?.find((a) => a?.toLowerCase()?.includes('admin'))

	return (
		<Card>
			<CardHeader title="General Info" />
			<CardContent>
				<div className={classes.grid}>
					<div className={classes.fileUpload}>
						<input
							accept="image/*"
							className={classes.input}
							id="icon-button-file"
							type="file"
							disabled={!staffMember.active}
							ref={inputRef}
							onChange={(e) => uploadPhoto(e)}
						/>
						<label htmlFor="icon-button-file" style={{ position: 'relative' }}>
							{loading ? <LoadingOverlayContained /> : null}
							<ButtonBase
								className={classes.imageUploadButton}
								component="span"
								disabled={!staffMember.active}>
								{staffMember.image_url ? (
									<Avatar
										className={classes.petProfileImage}
										src={`${imageRepo}${staffMember.image_url}`}
									/>
								) : (
									renderImageUpload()
								)}
							</ButtonBase>
						</label>
					</div>
					<div className={classes.fieldWrapper}>
						<TextField
							label="First Name *"
							variant="filled"
							value={staffMember.first_name}
							disabled={!staffMember.active}
							onChange={(e) =>
								setCurrent({
									...staffMember,
									first_name: e.target.value
								})
							}
						/>
					</div>
					<div className={classes.fieldWrapper}>
						<TextField
							label="Last Name *"
							variant="filled"
							value={staffMember.last_name}
							disabled={!staffMember.active}
							onChange={(e) => setCurrent({ ...staffMember, last_name: e.target.value })}
						/>
					</div>
					<div className={classes.fieldWrapper}>
						<TextField
							select
							label="Gender"
							variant="filled"
							value={staffMember.gender}
							disabled={!staffMember.active}
							onChange={(e) => setCurrent({ ...staffMember, gender: e.target.value })}>
							{staffSexOptions.map((sex) => (
								<MenuItem key={sex} value={sex}>
									{sex}
								</MenuItem>
							))}
						</TextField>
					</div>
					<div className={classes.fieldWrapper}>
						<TextField
							variant="filled"
							select
							value={staffMember.facility_id || ''}
							label="Facility *"
							disabled={facilitiesLoading || !staffMember.active}
							onChange={(e) => {
								const facility = (facilities || []).find(
									(item) => String(item._id) === String(e.target.value)
								)
								setCurrent({
									...staffMember,
									facility_id: e.target.value,
									market_id: facility?.market_id || staffMember.market_id
								})
							}}>
							{(facilities || []).length > 0 ? (
								(facilities || [])
									.filter(
										(facility) =>
											facility.active ||
											String(facility._id) === String(staffMember.facility_id)
									)
									.sort((a, b) => (a.name || '').localeCompare(b.name || ''))
									.map((facility) => (
										<MenuItem key={facility._id} value={facility._id}>
											{facility.market?.city
												? `${facility.name} (${facility.market.city})`
												: facility.name}
										</MenuItem>
									))
							) : (
								<MenuItem value="">No Facilities</MenuItem>
							)}
						</TextField>
					</div>
					{/*<div className={classes.fieldWrapper}>
						<TextField
							label="Homebase ID"
							variant="filled"
							value={staffMember.homebase_id}
							disabled={!staffMember.active}
							onChange={(e) => setCurrent({ ...staffMember, homebase_id: e.target.value })}
						/>
						</div>*/}
					<div className={classes.fieldWrapper}>
						<TextField
							label="Deputy ID"
							variant="filled"
							value={staffMember.deputy_id}
							disabled={!staffMember.active}
							onChange={(e) => setCurrent({ ...staffMember, deputy_id: e.target.value })}
						/>
					</div>
					<div className={classes.fieldWrapper}>
						<TextField
							label="Paychex ID"
							variant="filled"
							value={staffMember.paychex_id}
							disabled={!staffMember.active}
							onChange={(e) => setCurrent({ ...staffMember, paychex_id: e.target.value })}
						/>
					</div>
				</div>
				<div className={classes.gridDouble}>
					<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
						<div className={classes.fieldWrapper}>
							<TextField
								label="Email *"
								variant="filled"
								value={staffMember.email}
								disabled={!staffMember.active}
								onChange={(e) => setCurrent({ ...staffMember, email: e.target.value })}
							/>
						</div>
					</div>
					<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
						<TextField
							label="Phone *"
							variant="filled"
							value={staffMember.contact.phone_number}
							error={
								staffMember.contact.phone_number &&
								onlyNumbers(staffMember.contact.phone_number)?.length !== 10
							}
							InputProps={{
								inputComponent: TextMaskCustom
							}}
							disabled={!staffMember.active}
							onChange={(e) =>
								setCurrent({
									...staffMember,
									contact: { phone_number: e.target.value }
								})
							}
						/>
					</div>
					<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
						<div className={classes.fieldWrapper}>
							<TextField
								select
								label="Position"
								variant="filled"
								value={staffMember.position}
								disabled={!staffMember.active}
								onChange={(e) =>
									setCurrent({
										...staffMember,
										position: e.target.value
									})
								}>
								{staffPositionOptions.map((position) => (
									<MenuItem key={position} value={position}>
										{position}
									</MenuItem>
								))}
							</TextField>
						</div>
					</div>

					<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
						<Autocomplete
							multiple
							disableCloseOnSelect
							size="small"
							id="meal-cadence"
							className={classes.autoComplete}
							options={staffTrainingOptions}
							value={staffMember.trainings_completed}
							onChange={(e, v) => updateStaffState('trainings_completed', v)}
							onClose={(e) => {
								e.target.value = ''
							}}
							disabled={!staffMember.active}
							renderTags={(selected) =>
								selected.map((value) => (
									<DeletableChip
										key={value}
										label={value}
										{...{
											onDelete: staffMember.active ? () => removeTraining(value) : null
										}}
									/>
								))
							}
							renderOption={(option, { selected }) => (
								<React.Fragment>
									<Checkbox checked={selected} />
									<ListItemText style={{ textTransform: 'capitalize' }} primary={option} />
								</React.Fragment>
							)}
							renderInput={(params) => (
								<TextField {...params} fullWidth variant="filled" label="Trainings" />
							)}
						/>
					</div>
				</div>

				<div className={clsx([classes.fieldWrapper, 'field-wrapper'])} style={{ marginTop: 24 }}>
					<Autocomplete
						multiple
						disableCloseOnSelect
						size="small"
						id="apps"
						className={classes.autoComplete}
						options={appOptions}
						value={staffMember.apps || []}
						onChange={(e, v) => updateStaffState('apps', v)}
						onClose={(e) => {
							e.target.value = ''
						}}
						disabled={!staffMember.active}
						renderTags={(selected) =>
							selected.map((value) => (
								<DeletableChip
									key={value}
									label={value}
									{...{
										onDelete: staffMember.active ? () => removeApp(value) : null
									}}
								/>
							))
						}
						renderOption={(option, { selected }) => (
							<React.Fragment>
								<Checkbox checked={selected} />
								<ListItemText style={{ textTransform: 'capitalize' }} primary={option} />
							</React.Fragment>
						)}
						renderInput={(params) => (
							<TextField {...params} fullWidth variant="filled" label="App Access *" />
						)}
					/>
				</div>

				{hasAdminAccess && (
					<div className={clsx([classes.fieldWrapper, 'field-wrapper'])} style={{ marginTop: 24 }}>
						<Autocomplete
							multiple
							disableCloseOnSelect
							size="small"
							id="meal-cadence"
							className={classes.autoComplete}
							options={visibleRoleOptions}
							value={staffMember.roles || []}
							onChange={(e, v) => {
								let nextRoles = v
								if (!isSuperUser) {
									nextRoles = v.filter((role) => role !== USER_ROLES.SuperUser)
									if ((staffMember.roles || []).includes(USER_ROLES.SuperUser)) {
										nextRoles = [...nextRoles, USER_ROLES.SuperUser]
									}
								}
								updateStaffState('roles', nextRoles)
							}}
							onClose={(e) => {
								e.target.value = ''
							}}
							disabled={!staffMember.active}
							renderTags={(selected) =>
								selected.map((value) => (
									<DeletableChip
										key={value}
										label={value}
										{...{
											onDelete: canEditRole(value) ? () => removePermission(value) : null
										}}
									/>
								))
							}
							renderOption={(option, { selected }) => (
								<React.Fragment>
									<Checkbox checked={selected} />
									<ListItemText style={{ textTransform: 'capitalize' }} primary={option} />
								</React.Fragment>
							)}
							renderInput={(params) => (
								<TextField {...params} fullWidth variant="filled" label="Admin Permissions" />
							)}
						/>
					</div>
				)}
				{staffMember.position === 'Groomer' || staffMember.position === 'Groom Tech' ? (
					<div
						style={{
							marginTop: 24,
							width: '100%',
							display: 'flex',
							flexDirection: 'row',
							justifyContent: 'space-between'
						}}>
						<TextField
							select
							label="Speed Factor"
							variant="filled"
							value={staffMember.speed_factor}
							disabled={!staffMember.active}
							helperText="A higher speed factor should be applied (1+) for faster groomers who want more grooms."
							onChange={(e) =>
								setCurrent({
									...staffMember,
									speed_factor: e.target.value
								})
							}>
							{speed_factors.map((position) => (
								<MenuItem key={position} value={position}>
									{position}
								</MenuItem>
							))}
						</TextField>

						<Autocomplete
							multiple
							disableCloseOnSelect
							size="small"
							id="meal-cadence"
							className={classes.autoComplete}
							options={grooming_services}
							value={staffMember.permitted_grooming_services}
							onChange={(e, v) => updateStaffState('permitted_grooming_services', v)}
							onClose={(e) => {
								e.target.value = ''
							}}
							disabled={!staffMember.active}
							renderTags={(selected) =>
								selected.map((value) => (
									<DeletableChip
										key={value}
										label={value}
										{...{
											onDelete: staffMember.active ? () => removeService(value) : null
										}}
									/>
								))
							}
							getOptionDisabled={(option) =>
								option === 'haircut' && staffMember.position !== 'Groomer'
							}
							renderOption={(option, { selected }) => (
								<React.Fragment>
									<Checkbox checked={selected} />
									<ListItemText style={{ textTransform: 'capitalize' }} primary={option} />
								</React.Fragment>
							)}
							renderInput={(params) => (
								<TextField
									{...params}
									fullWidth
									variant="filled"
									label="Permitted Grooming Services"
								/>
							)}
						/>
					</div>
				) : null}
			</CardContent>
			{staffMember?._id && (
				<CardActions className={classes.cardActions}>
					{staffMember.active && staffMember?.uid_map?.length ? (
						<Button variant="outlined" color="secondary" onClick={handlePasswordResetClick}>
							Reset Password
						</Button>
					) : (
						<div></div>
					)}
					{staffMember.active ? (
						<Button
							variant="outlined"
							className={classes.deleteButton}
							onClick={() => setIsDeactivationDialogShown(true)}>
							Deactivate
						</Button>
					) : (
						<Button
							variant="outlined"
							color="secondary"
							onClick={() => setIsActivationDialogShown(true)}>
							Activate
						</Button>
					)}
				</CardActions>
			)}
			<Confirmation
				title="Activate Staff"
				isShown={isActivationDialogShown}
				setIsShown={setIsActivationDialogShown}
				confirm={() => updateStaffActiveStatus(true)}
				confirmTitle={'Activate'}
				message={'This action will allow this individual staff Member to be used in the system.'}
			/>
			<Confirmation
				title="Deactivate Staff"
				isShown={isDeactivationDialogShown}
				setIsShown={setIsDeactivationDialogShown}
				confirm={() => updateStaffActiveStatus(false)}
				confirmTitle={'Deactivate'}
				message={'This action will lock this individual staff Member out of the system.'}
			/>
		</Card>
	)
}

export default withFirebaseHOC(StaffInfoCard)
